import { render, staticRenderFns } from "./I2SaveButton.vue?vue&type=template&id=3075fd88&scoped=true"
import script from "./I2SaveButton.vue?vue&type=script&lang=js"
export * from "./I2SaveButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3075fd88",
  null
  
)

export default component.exports